import {Component, ElementRef, HostListener, Input, OnDestroy} from "@angular/core";
import {FUIOptionsService, SelectionEvent} from "../../../framework/options.service";
import {Subscription} from "rxjs";
import {FUIAbstractOption} from "../../../framework/abstract-option";
import {FUIIcon} from "../../../../icons/icon/icon.model";

@Component({
    selector: "fui-select-option",
    styleUrls: ["./select-option.component.scss"],
    templateUrl: "./select-option.component.html"
})
export class FUISelectOptionComponent extends FUIAbstractOption implements OnDestroy {
    @Input() icon: FUIIcon;
    @Input() optionElementHandler: (option: any, elementRef: ElementRef) => void;

    private _$selection: Subscription;

    constructor(optionsService: FUIOptionsService, private elementRef: ElementRef) {
        super(optionsService);
        this.tabindex = 0;
    }

    ngOnInit(): void {
        this._$selection = this.optionsService.selection$.subscribe((event: SelectionEvent) => {
            if (event.selection) {
                if (event.selection[this.field] != undefined) {
                    if (this.option[this.field] === event.selection[this.field]) {
                        if (this.option) {
                            this._valued = true;
                        }
                    } else {
                        this._valued = false;
                    }
                }
            } else {
                this._valued = false;
            }
        });

        if (this.optionElementHandler) {
            this.optionElementHandler(this.option, this.elementRef);
        }
    }

    ngOnDestroy(): void {
        this._$selection.unsubscribe();
    }

    /**
     * Set option as active in service
     */
    public selectOption(): void {
        this.optionsService.selectOption(this.option);
    }

    /**
     * Select the option on keypress of enter or space
     * @param {KeyboardEvent} keyboardEvent
     */
    @HostListener("keypress", ["$event"])
    public keypress(keyboardEvent: KeyboardEvent): void {
        if (keyboardEvent.code === "Enter" || keyboardEvent.code === "Space" || keyboardEvent.key === "Enter" || keyboardEvent.key === " ") {
            this.selectOption();
            keyboardEvent.preventDefault();
            keyboardEvent.stopPropagation();
        }
    }
}
